import { useFormik } from 'formik';
import {
  // FormControl,
  // FormHelperText,
  // Grid,
  IconButton,
  InputAdornment,
  // InputLabel,
  // MenuItem,
  // Select,
  Stack,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
// import { createWhatsappLogin } from '../../../store/whatsappLogin/api';
import { setItem } from '../../../utils/localStorage';
// import { useNavigate } from 'react-router-dom';
// import { COUNTRY_CODE } from '../../../constants';
import { authenticateUser } from '../../../store/auth/api';
import { login } from '../../../store/auth/authSlice';
import { clone, set } from 'lodash';
import Iconify from '../../../components/Iconify';
import { useRef, useState } from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { config } from '../../../utils/utils';
import LoginSchema from '../../../validation/loginSchema';
import { SuperUserRole } from '../../../enum';
import { toast } from 'react-toastify';

const LoginForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  // const navigate = useNavigate();
  const captchaRef = useRef<HCaptcha>(null);
  const [showPassword, setShowPassword] = useState(false);

  const {
    handleSubmit,
    resetForm,
    isSubmitting,
    // handleChange,
    values,
    touched,
    errors,
    setFieldValue,
    getFieldProps,
  } = useFormik({
    initialValues: {
      // countryCallingCode: '+974',
      // mobileNumber: '',
      email: '',
      password: '',
      strategy: 'local',
      captchaCode: '',
    },
    validationSchema: LoginSchema,
    onSubmit: async () => {
      try {
        const updatedValues = set(
          clone(values),
          'email',
          values.email.toLowerCase()
        );
        const res = await dispatch(authenticateUser(updatedValues)).unwrap();
        if (res?.accessToken) {
          if (
            res.user.userRole === SuperUserRole.admin ||
            res.user.userRole === SuperUserRole.adminTier2 ||
            res.user.userRole === SuperUserRole.adminTier3
          ) {
            setItem('info', res?.user);
            // Store the user role in localStorage for logout redirect
            localStorage.setItem('lastUserRole', res.user.userRole);
            dispatch(login({ accessToken: res?.accessToken, user: res?.user }));
            resetForm();
          } else {
            toast.error('Invalid Log in');
          }
        }
      } catch (error: any) {}
    },
  });

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const onExpire = () => {
    setFieldValue('captchaCode', '');
  };

  return (
    <form
      autoComplete='off'
      noValidate
      onSubmit={handleSubmit}
    >
      <Stack spacing={3}>
        {/* <Grid
          container
          spacing={3}
          sx={{ width: '100%' }}
        >
          <Grid
            xs={4}
            sm={4}
            md={4}
            lg={4}
          >
            <FormControl
              sx={{
                width: { xs: '100%', sm: '100%' },
              }}
              error={Boolean(
                touched?.countryCallingCode && errors?.countryCallingCode
              )}
            >
              <InputLabel>{'Code'}</InputLabel>
              <Select
                name='countryCallingCode'
                labelId='countryCallingCode'
                id='countryCallingCode'
                value={values.countryCallingCode}
                label={'Code'}
                onChange={(e) =>
                  setFieldValue('countryCallingCode', e.target.value)
                }
                MenuProps={{
                  style: {
                    maxHeight: 400,
                  },
                }}
              >
                {COUNTRY_CODE?.map((country) => (
                  <MenuItem
                    key={country.name}
                    value={country.code}
                  >
                    {country.code} {country.name}
                  </MenuItem>
                ))}
              </Select>
              {Boolean(
                touched.countryCallingCode && errors.countryCallingCode
              ) && (
                <FormHelperText>{errors?.countryCallingCode}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid
            xs={8}
            sm={8}
            md={8}
            lg={8}
            pl={2}
          >
            <TextField
              fullWidth
              label={'Mobile Number'}
              name='mobileNumber'
              id='mobileNumber'
              onChange={handleChange}
              value={values.mobileNumber}
            />
          </Grid>
        </Grid> */}

        <TextField
          fullWidth
          autoComplete='username'
          type='email'
          label={'Email Address'}
          {...getFieldProps('email')}
          error={Boolean(errors.email && touched.email)}
          helperText={Boolean(errors.email && touched.email) && errors.email}
        />

        <TextField
          fullWidth
          autoComplete='current-password'
          type={showPassword ? 'text' : 'password'}
          label={'Password'}
          {...getFieldProps('password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton
                  onClick={handleShowPassword}
                  edge='end'
                >
                  <Iconify
                    icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
          error={Boolean(errors.password && touched.password)}
          helperText={
            Boolean(errors.password && touched.password) && errors.password
          }
        />
      </Stack>

      <Stack
        justifyContent={'center'}
        alignItems={'center'}
        sx={{ my: 2, overflowX: 'auto' }}
      >
        <HCaptcha
          sitekey={config.H_CAPTCHA_SITEKEY ?? ''}
          onVerify={(captchaCode: string) => {
            setFieldValue('captchaCode', captchaCode);
          }}
          onExpire={onExpire}
          ref={captchaRef}
        />
      </Stack>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ my: 1 }}
      ></Stack>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
      >
        <LoadingButton
          fullWidth
          size='large'
          type='submit'
          variant='contained'
          loading={isSubmitting}
        >
          {'Login'}
        </LoadingButton>
      </Stack>
    </form>
  );
};
export default LoginForm;
